module.exports = __webpack_public_path__ + "img/gpx-icon.1d2b982d.svg";